import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function RollerCoefficientRow() {
   return (
      <InputRangeRow
         titleProp={"Roller Coefficient"}
         descriptionProp={""}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0}
         maxProp={1500}
         propertyNameProp={"rollerCoefficient"}
         errorDialogueProp={"0-1,500 only"}
         floatProp={false}
      />
   );
}
